// extracted by mini-css-extract-plugin
module.exports = {"details":"_4UZ8L","arrow":"_3DIK4","contentWrapper":"_3Q6UO","title":"_28_pn","categoryLink":"_2YpQz","moreButton":"_2gdOX","statistics":"_3PNDu","buttonGroup":"_2x4Vk"};